import { Select as MuiSelect } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    root: {
        padding: 0,
        '& label.Mui-focused': {
            color: theme.text.subtitle,
        },
    }
}));

const Select = (props) => {
    const classes = useStyles();

    return (
        <MuiSelect className={classes.root} {...props}/>
    );
}

export default Select;